import { AlertOctagon, Phone, RotateCcw } from "lucide-react";
import { Shell } from "@/components/Shell";

export function UrgentHalt({ onRestart }) {
  return (
    <Shell showProgress={false}>
      <div
        className="mt-6 rounded-3xl bg-[hsl(var(--coral))]/15 border-2 border-[hsl(var(--coral))] p-6"
        data-testid="urgent-halt"
      >
        <div className="flex items-center gap-3 text-[hsl(var(--coral))]">
          <AlertOctagon className="h-8 w-8" aria-hidden="true" />
          <span className="cc-eyebrow text-[hsl(var(--coral))]">Atención urgente</span>
        </div>
        <h1 className="font-serif text-3xl sm:text-4xl mt-4 leading-tight">
          Busca atención de urgencia ahora
        </h1>
        <p className="mt-4 text-[hsl(var(--texto))] leading-relaxed">
          Por tu seguridad, deja de responder este cuestionario y contacta con un
          servicio médico de urgencia o acude al hospital más cercano.
        </p>

        <div className="mt-6 space-y-3">
          <div className="cc-card p-4 flex items-start gap-3">
            <Phone className="h-5 w-5 text-[hsl(var(--olivo))] mt-0.5 shrink-0" aria-hidden="true" />
            <div>
              <p className="font-medium">Llama al número local de emergencias</p>
              <p className="text-sm text-[hsl(var(--muted-foreground))]">
                O pide a alguien de confianza que te acompañe.
              </p>
            </div>
          </div>
        </div>

        <p className="mt-6 text-sm text-[hsl(var(--muted-foreground))]">
          Este mensaje es orientativo. No sustituye la evaluación médica profesional.
        </p>
      </div>

      <div className="mt-6">
        <button
          onClick={onRestart}
          className="cc-btn-outline w-full"
          data-testid="urgent-restart-btn"
        >
          <RotateCcw className="h-4 w-4" />
          Comenzar de nuevo
        </button>
      </div>
    </Shell>
  );
}
